// const REPORT_TYPE = {
//   j: 'journey',
//   r: 'raning',
//   t: 'trend'
// }

const PERIOD_TYPE = {
  sd: {
    ko: '최근 7일',
    en: 'Last 7 Days',
    ja: '直近7日間'
  },
  tw: {
    ko: '이번주',
    en: 'This Week',
    ja: '今週'
  },
  pw: {
    ko: '지난주',
    en: 'Last Week',
    ja: '先週'
  },
  tm: {
    ko: '이번달',
    en: 'This Month',
    ja: '今月'
  },
  pm: {
    ko: '지난달',
    en: 'Last Month',
    ja: '先月'
  }
}

const SEGMENT_TITLE = {
  r: {
    ko: '지표 기반 페이지 소비 분석',
    en: 'Metrics-Based Page Engagement Analysis',
    ja: '指標別ページパフォーマンス分析'
  },
  j: {
    ko: '여정 기반 서비스 탐색 분석',
    en: 'Journey-Based Service Exploration Analysis',
    ja: 'カスタマージャーニーに基づく行動分析'
  },
  tg: {
    ko: '타겟 페이지의 도달 경로',
    en: 'Target Page Reach Paths',
    ja: 'ターゲットページへの到達経路'
  },
  t: {
    ko: '페이지 기반 전환/이탈 분석',
    en: 'Page-Based Conversion/Exit Analysis',
    ja: 'ページのCV・離脱分析'
  }
}

const SEGMENT_TITLE_TYPE2 = {
  j: {
    p: {
      ko: 'Phone 핵심 고객 여정 분석',
      en: 'Phone Key Customer Journey Analysis',
      ja: 'デバイス別カスタマージャーニー分析(Phone)'
    },
    d: {
      ko: 'Desktop 핵심 고객 여정 분석',
      en: 'Desktop Key Customer Journey Analysis',
      ja: 'デバイス別カスタマージャーニー分析(Desktop)'
    },
    sr: {
      ko: '유입경로 1위 핵심 고객 여정 분석',
      en: 'Top Traffic Source Key Customer Journey Analysis',
      ja: '最も多い流入経路のカスタマージャーニー分析'
    },
    n: {
      ko: '신규 고객의 핵심 여정 분석',
      en: 'New Customer Key Journey Analysis',
      ja: '新規顧客のカスタマージャーニー分析'
    },
    r: {
      ko: '재방문 고객의 핵심 여정 분석',
      en: 'Returning Customer Key Journey Analysis',
      ja: '再訪問顧客のカスタマージャーニー分析'
    }
  },
  tg: {
    n: {
      ko: '신규 고객의 타겟 도달 경로',
      en: 'New Customer Reach Paths',
      ja: '新規顧客のターゲット到達経路'
    }
  },
  t: {
    p: {
      ko: 'Phone 탐색&소비 현황 분석',
      en: 'Phone Exploration & Engagement Status Analysis',
      ja: '探索とパフォーマンス分析(Phone)'
    },
    d: {
      ko: 'Desktop 탐색&소비 현황 분석',
      en: 'Desktop Exploration & Engagement Status Analysis',
      ja: '探索とパフォーマンス分析(Desktop)'
    },
    sr: {
      ko: '유입경로 1위 탐색&소비 현황 분석',
      en: 'Top Traffic Source Exploration & Engagement Analysis',
      ja: '最も多い流入経路の探索とパフォーマンス分析'
    },
    n: {
      ko: '신규 고객의 탐색&소비 현황 분석',
      en: 'New Customer Exploration & Engagement Analysis',
      ja: '新規顧客の探索とパフォーマンス分析'
    },
    r: {
      ko: '재방문 고객의 탐색&소비 현황 분석',
      en: 'Returning Customer Exploration & Engagement Analysis',
      ja: '再訪問顧客の探索とパフォーマンス分析'
    }
  }
}
export const getSegmentMetaTitle = (segmentKey, lang) => {
  const segArr = segmentKey.split('_')
  // const reportType = REPORT_TYPE[segArr[1]]
  const periodType = PERIOD_TYPE[segArr[3]][lang]
  const title = segArr.length > 4 ? SEGMENT_TITLE_TYPE2[segArr[1]][segArr[4]][lang] : SEGMENT_TITLE[segArr[1]][lang]
  return `[${periodType}] ${title}`
}

export const getSegmentDefault = (reportType, lang) => {
  return SEGMENT_TITLE[reportType[0]][lang]
}
